// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useMemo, useState} from 'react';
import {use_translation_v} from '../lib/trans_v';
import {Settings_context} from '../settings_ctx';
import util from '/util/util.js';
import {Input} from '../lib/input';
import {Select} from '../lib/select';
import {Button} from '../../../shared/button';
import {Modal} from '../../../shared/ui/modal';
import {Editor} from '../../../shared/editor/editor';
import {Navbar_logo} from '../ui/navbar/navbar_logo';
import {Svg_img} from '../ui/svg_img';
import cn from 'classnames';
// @ts-ignore
import {fetch} from '/util/fetch.js';
// @ts-ignore
import {is_valid_email} from '/util/url.js';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';
import styles from './change_plan_form.module.less';

const get_t = (t, key)=>{
    const res = t(key);
    if (res==key)
        return '';
    return res;
};
const t_to_array = (t, key)=>{
    let i = 0;
    const res = [];
    while (true)
    {
        const value = get_t(t, `${key}.${i}.value`);
        if (!value)
            break;
        const title = get_t(t, `${key}.${i}.title`) || value;
        res.push({value, title});
        i++;
    }
    return res;
};

interface i_change_plan_form_props {
  next_step_link: string;
}

export const Change_plan_form = ({next_step_link}: i_change_plan_form_props)=>{
    const {t, T} = use_translation_v({version: 0});
    const {theme} = useContext(Settings_context);
    // @ts-ignore
    const {user} = useContext(App_context);
    const [email, set_email] = useState(util.get(user, 'emails.0.value', ''));
    const [invoice, set_invoice] = useState('');
    const [plan, set_plan] = useState('');
    const [pay_method, set_pay_method] = useState('');
    const [errors, set_errors] = useState([]);
    const [is_shown, set_is_shown] = useState(false);
    const plans = useMemo(()=>{
        return t_to_array(t, 'refund.plans');
    }, []);
    const pay_methods = useMemo(()=>{
        return t_to_array(t, 'refund.methods');
    }, []);
    const is_submit_disabled = useMemo(()=>{
        if (!email || !plan || !pay_method || !invoice)
            return true;
        return false;
    }, [email, plan, pay_method, invoice]);
    const on_submit = (e: React.FormEvent<HTMLFormElement>)=>{
        e.preventDefault();
        submit_handler();
    };
    const submit_handler =()=>{
        const err = [];
        if (!email || !is_valid_email(email))
            err.push('email');
        if (!invoice)
            err.push('invoice');
        if (!pay_method)
            err.push('method');
        if (!plan)
            err.push('plan');
        set_errors(err);
        if (err.length==0)
        {
            set_is_shown(true);
            const body = {
                email,
                issue: ['replace_plan'],
                details: [[],
                  `invoice: ${invoice}, method ${pay_method}`,
                  `plan ${plan}`],
            };
            fetch('/refund'+location.search, {method: 'POST', body});
        }
    };
    const on_modal_close =()=>location.href = next_step_link;
    return <form className={styles.form} onSubmit={on_submit}>
      <Modal is_open={is_shown} on_close={on_modal_close}
        width={440}>
        <div>
          <Navbar_logo disabled cls={styles.logo_popup}/>
          <h5 className={cn(theme.logo_grey, styles.popup_h)}><b>
            <T i18nKey={'refund.popup_title'}/></b></h5>
          <p><T i18nKey={'refund.popup_text'}/></p>
          <Button cls={styles.popup_btn} caption={t('refund.popup_btn')}
            color={'white'} on_click={on_modal_close}/>
        </div>
      </Modal>
      <div className={styles.inputs_wrapper}>
        <div className={styles.inputs_container}>
          <Input
            label={t('refund.form_email')}
            placeholder={'john.doe@example.net'}
            value={email}
            cl={styles.form_field}
            on_change={set_email}
            error_style={errors.indexOf('email')>-1}/>
          <Select
            class_name={styles.form_field}
            items={plans}
            value={plan}
            on_select={(n, v)=>set_plan(v)}
            is_error={errors.indexOf('plan')>-1}
            label={t('refund.form_refund_plan')}/>
        </div>
        <div className={styles.inputs_container}>
          <Input
            label={t('refund.form_invoice')}
            placeholder={' '}
            value={invoice}
            cl={styles.form_field}
            on_change={set_invoice}
            error_style={errors.indexOf('invoice')>-1}/>
          <Select
            class_name={styles.form_field}
            items={pay_methods}
            value={pay_method}
            is_error={errors.indexOf('method')>-1}
            on_select={(n, v)=>set_pay_method(v)}
            label={t('refund.form_method')}/>
        </div>
        {errors.length>0 && <p
          className={cn(theme.p2, theme.bold, styles.error_text)}>
          <Svg_img id={'svg/icon/validation.svg'} w={12} h={12}/>
          <T i18nKey={'refund.form_error'}/> {errors.map(er=>{
              return t(`refund.form_${er}`);
          }).join(', ')}
        </p>}
      </div>
        <Button disabled={is_submit_disabled} cls={styles.button}
          on_click={submit_handler} caption={t('refund.form_button')}/>
    </form>;
};

interface i_change_plan_form_editor_props {
    value: i_change_plan_form_props;
    on_change: (v: i_change_plan_form_props)=>void;
}

export const Change_plan_form_editor = ({value,
    on_change}: i_change_plan_form_editor_props)=>{
    return <Editor editors={[
      {key: 'next_step_link', label: 'Next step link', type: 'text'}
    ]} value={value} on_change={on_change} />;
};
